import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom'

//Estilos
import '../App.css';
import { ArrowRightCircleFill } from 'react-bootstrap-icons';
import { MaterialSymbolsMenu } from "./visual/icons";

//media
import headerimg from '../media/headerimg.png';

function Headerappprivateadmin(props){
    const [role, setRole] = useState([]);
    const [fullname, setFullName] = useState();
    const [tipousuario, setTipoUsuario] = useState();
    const [casino, setCasino] = useState();
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    
    const roleList = role.map((item, i) => 
        <li key={i} className="list-none"><Link to={item.path+'/'+window.localStorage.getItem('MY_APP_STATE_AUTHCODE')}><span className='badge bg-secundary'>{item.nombre}</span></Link></li>
    );

    console.log(roleList)

    useEffect(() => {
        setRole(JSON.parse(window.localStorage.getItem('MY_APP_STATE_ROLE')))
        setFullName(window.localStorage.getItem('MY_APP_STATE_PROF_NAME').replace('"', '').replace('"',''))
        setTipoUsuario(window.localStorage.getItem('MY_APP_STATE_PROF_PROF').replace('"', '').replace('"',''))
    }, []);

    return (
        <>
            {/* Navbar */}
            <nav className="bg-[#5e2b41] py-3 px-4">
                <div className="flex items-center justify-between text-white">
                    {/* Role List for larger screens */}
                    <ul className="hidden lg:flex text-lg text-white gap-6 whitespace-nowrap w-full justify-start">
                        {roleList}
                    </ul>
                    {/* Hamburger Menu for smaller screens */}
                    <div className="lg:hidden object-end">
                        <MaterialSymbolsMenu onClick={toggleMenu} />
                    </div>
                </div>
            </nav>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="absolute w-full bg-[#5e2b41] bg-opacity-90 backdrop-blur text-white shadow-md z-40">
                    <ul className="py-2 space-y-4 px-4 ">{roleList}</ul>
                </div>
            )}

            <header className="text-center bg-[#f1f1f1] py-3">
                <h3>Bienvenido/a {fullname} {tipousuario}/a</h3>
            </header>
        </>
    )
}

export default Headerappprivateadmin

